document.addEventListener("DOMContentLoaded", function () {
    if (document.querySelector("[data-login-block]")) {
        import(/* webpackChunkName: "login-block" */ "/Features/Login/LoginBlock/js/login-block.js").then(async (module) => {
            const login = new module.default();
            await login.init();
        });
    }
});